import { useSelector } from 'react-redux';
function useGetUserToken() {
  const token = useSelector((state) => state.auth.userToken);
  return token;
}
export default useGetUserToken;